import { Logo2025Button } from './Logo2025Button'

export default Logo2025Button
